module.exports = __webpack_public_path__ + "static/media/landing.b80c40d9.svg";